<template>
  <div>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-toolbar dense class="toolbar" flat color="white">
        <v-toolbar-title>Notices</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row dense justify="center">
          <v-col cols="12" sm="5" md="5">
            <v-combobox
              v-model="selected_children"
              :items="children"
              label="Select Child"
              outlined
              dense
              prepend-icon="mdi-account-child-circle"
              @change="displayNotice()"
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row dense justify="center">
          <v-col cols="12" sm="4" md="3">
            <span v-for="header in headers" :key="header.text">
              <span v-if="filters.hasOwnProperty(header.value)">
                <v-autocomplete
                  class="mr-2 pb-5 pt-2"
                  flat
                  hide-details
                  small
                  rounded
                  dense
                  outlined
                  color="#0F2027"
                  :label="header.text"
                  multiple
                  clearable
                  :items="columnValueList(header.value)"
                  v-model="filters[header.value]"
                ></v-autocomplete>
              </span>
            </span>
          </v-col>
          <v-col cols="12" sm="1" md="1"></v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              placeholder="Search by Title / Decription / Date"
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <br />
    <v-card class="box" v-if="child_notice == null">
      <center>
        <h3 style="color: green">Currently there are no notices added.</h3>
      </center>
    </v-card>
    <v-row dense v-if="child_notice != null">
      <v-col
        cols="12"
        sm="6"
        md="6"
        v-for="notice in searchByTitleOrDescription"
        :key="notice.id"
      >
        <v-card class="box" :elevation="2" height="100%">
          <v-chip class="ma-2" :color="!notice.visited ? 'warning' : 'info'">
            {{ notice.issue_date }} -- {{ notice.registration_number }}
          </v-chip>
          <v-chip class="ma-2" :color="!notice.visited ? 'warning' : 'info'">
            {{ notice.academicyear }}
          </v-chip>
          <v-card-title class="title font-weight-regular">
            {{ notice.title }}
          </v-card-title>
          <v-card-title
            class="title font-weight-regular"
            v-if="notice.webinar_link != null && notice.webinar_link != '--'"
          >
            <a class="p-2" :href="notice.webinar_link" target="blank">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-if="notice.webinar_link"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="black">mdi-eye</v-icon></v-btn
                  >
                </template>
                <span> Visit Link !!! </span>
              </v-tooltip>
            </a>
          </v-card-title>
          <v-card-title class="body-2 font-weight-regular">
            <v-btn
              class="ma-2"
              small
              outlined
              color="indigo"
              v-if="!notice.visited"
              @click="viewMore(notice)"
              >View More</v-btn
            >
            <span v-if="notice.visited"
              >Description:<span v-html="notice.description"></span>
            </span>
          </v-card-title>

          <v-card-actions>
            <v-card-subtitle v-if="notice.attachment" class="font-regular">
              Downloadable Attachment

              <span v-for="(item, i) in notice.attachment_links" :key="i">
                <a
                  class="p-2"
                  :href="basepath + item.path + item.name"
                  target="blank"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-if="notice.attachment != null"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="black">mdi-download</v-icon></v-btn
                      >
                    </template>
                    <span> View Attachment File!!! </span>
                  </v-tooltip>
                </a>
              </span>
            </v-card-subtitle>
            <v-spacer> </v-spacer
            ><v-card-subtitle
              ><b> from @{{ notice.from }}</b></v-card-subtitle
            >
          </v-card-actions>
        </v-card>
      </v-col>
      <br />
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    basepath: "",
    child_info: [],
    children: [],
    selected_children: "",
    child_notice: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    loader: true,
    search: "",
    s3url: "",
    selected_children_gr: "",
    notice_title: null,
    ay_list: [],
    ay: "",
    headers: [{ text: "Academic Year", value: "academicyear" }],
    filters: {
      academicyear: [],
    },
  }),

  methods: {
    columnValueList(val) {
      return this.child_notice ? this.child_notice.map((d) => d[val] || 'N/A') : [];
    },
    viewMore(notice) {
      console.log("Viewing notice:", notice); // Debug: Log notice being viewed
      const formData = {
        id: notice.comm_parent_id || notice.notice_id, // Fallback to notice_id
        type: "Notice",
      };
      axios
        .post("/parent/noticeOrAlbumViewedByParent", formData)
        .then((res) => {
          if (res.data.msg == "200" && res.data.status == "SUCCESS") {
            notice.visited = true;
            this.snackbar_msg = "Notice marked as viewed!";
            this.snackbar = true;
            this.color = "success";
          } else {
            this.snackbar_msg = res.data.status_reason || "Failed to mark notice as viewed!";
            this.snackbar = true;
            this.color = "error";
          }
        })
        .catch((error) => {
          console.error("Error marking notice as viewed:", error);
          this.snackbar_msg = "An error occurred while marking the notice as viewed.";
          this.snackbar = true;
          this.color = "error";
        })
        .finally(() => {
          this.loader = false;
        });
    },
    downloadNoticeAttachment(dlinkpath) {
      console.log("Downloading attachments:", dlinkpath); // Debug: Log attachments
      for (let j = 0; j < dlinkpath.length; j++) {
        var link = document.createElement("a");
        let path = dlinkpath[j].path;
        link.download = dlinkpath[j].name;
        link.href = this.s3url + path + link.download;
        link.target = "_blank";
        link.click();
      }
    },
    childrenList() {
      console.log("Child info:", this.child_info); // Debug: Log child info
      for (let i = 0; i < this.child_info.length; i++) {
        this.children.push(
          this.child_info[i].grno + ":" + this.child_info[i].name
        );
        if (i === 0) {
          this.selected_children =
            this.child_info[i].grno + ":" + this.child_info[i].name;
        }
      }
      this.displayNotice();
    },
    // displayNotice() {
    //   // Check if a specific notice is selected from sessionStorage
    //   const selectedNotice = sessionStorage.getItem("selected_notice");
    //   console.log("Selected notice from sessionStorage:", selectedNotice); // Debug: Log sessionStorage
    //   if (selectedNotice) {
    //     const notice = JSON.parse(selectedNotice);
    //     console.log("Parsed notice:", notice); // Debug: Log parsed notice
    //     // Map fields to match getNoticeHWAlbum structure
    //     this.child_notice = [{
    //       id: notice.notice_id || Date.now(), // Fallback ID
    //       notice_id: notice.notice_id,
    //       comm_parent_id: notice.notice_id, // Use notice_id as comm_parent_id
    //       registration_number: notice.learner || 'N/A', // Map learner to registration_number
    //       academicyear: notice.ay || 'N/A', // Map ay to academicyear
    //       title: notice.title || 'No Title',
    //       issue_date: notice.post_date || 'N/A', // Map post_date to issue_date
    //       description: notice.description || 'No Description', // Default for missing field
    //       from: notice.from || 'School', // Default for missing field
    //       webinar_link: notice.webinar_link || null, // Default for missing field
    //       attachment: notice.attachment || 0, // Default for missing field
    //       attachment_links: notice.attachment_links || [], // Default for missing field
    //       visited: notice.visited || false // Default for missing field
    //     }];
    //     return;
    //   }

    //   // Otherwise, display notices based on selected child
    //   let grno = this.selected_children;
    //   if (!grno) {
    //     console.log("No selected child, cannot display notices");
    //     return;
    //   }

    //   let res = grno.split(":");
    //   console.log("Selected child grno:", res[0]); // Debug: Log selected child
    //   for (let i = 0; i < this.child_info.length; i++) {
    //     if (res[0] == this.child_info[i].grno) {
    //       this.child_notice = this.child_info[i].notices || [];
    //       console.log("Child notices:", this.child_notice); // Debug: Log notices
    //       break;
    //     }
    //   }
    // },
    displayNotice() {
  const selectedNotice = sessionStorage.getItem("selected_notice");
  console.log("Selected notice from sessionStorage:", selectedNotice);
  if (selectedNotice) {
    const notice = JSON.parse(selectedNotice);
    console.log("Parsed notice:", notice);

    // Map academic year ID to string if ay_list is available
    let academicYear = notice.ay || 'N/A';
    if (this.ay_list && this.ay_list.length > 0 && notice.ay) {
      const ayObj = this.ay_list.find(ay => ay.id == notice.ay); // Loose comparison for ID
      academicYear = ayObj ? ayObj.ay : 'N/A';
      console.log("Mapped academic year:", academicYear); // Debug mapping
    } else {
      console.log("ay_list not available yet, using fallback:", academicYear);
    }

    this.child_notice = [{
      id: notice.notice_id || Date.now(),
      notice_id: notice.notice_id,
      comm_parent_id: notice.notice_id,
      registration_number: notice.learner || 'N/A',
      academicyear: academicYear, // Use mapped academic year
      title: notice.title || 'No Title',
      issue_date: notice.post_date || 'N/A',
      description: notice.description || 'No Description',
      from: notice.from || 'School',
      webinar_link: notice.webinar_link || null,
      attachment: notice.attachment || 0,
      attachment_links: notice.attachment_links || [],
      visited: notice.visited || false
    }];
    console.log("Child notice set:", this.child_notice);
    return;
  }

  // Handle non-sessionStorage case
  let grno = this.selected_children;
  if (!grno) {
    console.log("No selected child, cannot display notices");
    return;
  }

  let res = grno.split(":");
  console.log("Selected child grno:", res[0]);
  for (let i = 0; i < this.child_info.length; i++) {
    if (res[0] == this.child_info[i].grno) {
      this.child_notice = this.child_info[i].notices || [];
      console.log("Child notices:", this.child_notice);
      break;
    }
  }
},
    getMotices() {
      const formData = {
        type: "Notice",
        ay: this.ay || sessionStorage.getItem("selected_ay") || "",
      };
      console.log("Fetching notices with formData:", formData); // Debug: Log formData
      axios
        .post("/parent/getNoticeHWAlbum", formData)
        .then((res) => {
          if (res.data.msg == "200" && res.data.status == "SUCCESS") {
            this.child_info = res.data.child_info || [];
            this.ay_list = res.data.ay_list || [];
            console.log("Fetched child_info:", this.child_info); // Debug: Log child_info
            this.childrenList();
          } else {
            this.snackbar_msg = res.data.status_reason || "Failed to load notices!";
            this.snackbar = true;
            this.color = "error";
          }
        })
        .catch((error) => {
          console.error("Error fetching notices:", error);
          this.snackbar_msg = "An error occurred while fetching notices.";
          this.snackbar = true;
          this.color = "error";
        })
        .finally(() => {
          this.loader = false;
        });
    },
  },
  mounted() {
    this.basepath = localStorage.getItem("awspath");
    this.s3url = localStorage.getItem("awspath");
    console.log("Mounted: Checking for selected notice"); // Debug: Log mount
    const selectedNotice = sessionStorage.getItem("selected_notice");
    if (selectedNotice) {
      this.displayNotice();
      this.getMotices();
    } else {
      this.getMotices();
    }
  },
  computed: {
    searchByTitleOrDescription() {
      let grno = this.selected_children;
      let res = grno ? grno.split(":") : [];
      if (!this.child_notice) {
        console.log("No notices to filter"); // Debug: Log empty notices
        return [];
      }
      console.log("Filtering notices:", this.child_notice); // Debug: Log notices before filtering
      return this.child_notice.filter((tbdata) => {
        return Object.keys(this.filters).every((f) => {
          const value = tbdata[f] || 'N/A';
          return (
            (this.filters[f].length < 1 || this.filters[f].includes(value)) &&
            (tbdata.title.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
             tbdata.description.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
             tbdata.issue_date.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
          );
        });
      });
    },
  },
  beforeDestroy() {
    // Clear sessionStorage to prevent stale data
    sessionStorage.removeItem("selected_notice");
    sessionStorage.removeItem("selected_ay");
    sessionStorage.removeItem("selected_learner");
  },
};
</script>